export const localizePath = (originalPath, locale, intl = {}) => {
  let path = originalPath;
  const { locales = {}, translatedPaths = [] } = intl;
  const { translations = [], default: defaultLocale } = locales;

  if (!path) return null;

  let pathPrefix = null;
  // Find pathPrefix (if we are not localizing default locale)
  if (locale !== defaultLocale) {
    const activeTranslation =
      translations.find(
        ({ hreflang: translationLocale }) => translationLocale === locale
      ) || {};

    pathPrefix = activeTranslation.pathPrefix;

    if (!pathPrefix)
      throw Error(
        `Locale ${locale} can't be found in translations.`,
        translations
      );
  }

  // check if there exists a translated path
  const translatedPathObject = translatedPaths.find(
    (translatedPath) =>
      `/${translatedPath.default}/` === path ||
      `/${translatedPath.default}` === path
  );
  const translatedPath =
    translatedPathObject && translatedPathObject[locale]
      ? translatedPathObject[locale]
      : null;

  // do create consistency for our SEO linking we add a slash to the end of all our links
  // below you can see we always add a slash for all our translated paths as well
  if (path[path.length - 1] !== '/') {
    path = path + '/';
  }

  // construct path for default locale
  if (!pathPrefix) return translatedPath ? `/${translatedPath}/` : path;

  // construct paths with pathPrefix
  if (translatedPath) return `/${pathPrefix}/${translatedPath}/`;
  return `/${pathPrefix}${path}`;
};
